import WarningsCard from './WarningsCard';

export default WarningsCard;